import { AxiosError, AxiosResponse } from 'axios';
import { ref } from 'vue';
import { serialTimeService } from '@/shared/services/SerilalTime/SerialTimeService';
import { authService, HttpClientFactory } from '@/shared/services';

const QUESTIONNAIRE_ANSWER_URL = '/api/v1/access/access-sessions/questionnaire-answer';
const QUESTIONNAIRE_CONFIRMATION_URL = '/api/v1/access/access-sessions/questionnaire-confirmation';

export const pendingRequestsCount = ref(0);
export const failedRequestsCount = ref(0);

export function submitQuestionnaireAnswer(evt: any): Promise<any> {
  pendingRequestsCount.value += 1;

  return HttpClientFactory.baseClient
    .post(`${QUESTIONNAIRE_ANSWER_URL}/${authService.getSessionId()}`, {
      ...evt,
      serialTime: serialTimeService.time,
    })
    .then((res: AxiosResponse) => res.data)
    .catch(() => { failedRequestsCount.value += 1; })
    .finally(() => {
      pendingRequestsCount.value -= 1;
    });
}

/**
 * Confirms Questionnaire submission
 *
 * BE will compare UI state with the calculated one, and store a Questionnaire snapshot into data.
 * It will also store a Questionnaire Overview snapshot until we made it calculated, and set questionnaireFinalized.
 *
 * @param questionnaire pass UI questionnaire state to compare with the calculated one
 * @param questionnaireOverview pass UI questionnaire overview state to store
 */
export function submitQuestionnaireConfirmation(questionnaire, questionnaireOverview): Promise<any> {
  return HttpClientFactory.baseClientSilent
    .post(`${QUESTIONNAIRE_CONFIRMATION_URL}/${authService.getSessionId()}`, { questionnaire, questionnaireOverview })
    .then((res: AxiosResponse) => res.data);
}
